var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocSampleToggle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1074 9L7.43821 11.7545C7.31274 11.884 7.25 12.0488 7.25 12.2489C7.25 12.449 7.31274 12.6138 7.43821 12.7433C7.56369 12.8728 7.72338 12.9375 7.9173 12.9375C8.11122 12.9375 8.27091 12.8728 8.39639 12.7433L11.5447 9.49439C11.6816 9.35314 11.75 9.18834 11.75 9C11.75 8.81166 11.6816 8.64686 11.5447 8.50561L8.39639 5.25673C8.27091 5.12724 8.11122 5.0625 7.9173 5.0625C7.72338 5.0625 7.56369 5.12724 7.43821 5.25673C7.31274 5.38621 7.25 5.55101 7.25 5.75112C7.25 5.95123 7.31274 6.11603 7.43821 6.24552L10.1074 9Z",
    fill: "#242424"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocSampleToggle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doc-sample-toggle.41725043db9f4aa2601e512190535dd3.svg";